// extracted by mini-css-extract-plugin
export var boldText = "_6j-4";
export var checkboxContainer = "_6j-6";
export var closeIcon = "_6j-i";
export var container = "_6j-0";
export var drawer = "_6j-8";
export var drawerContent = "_6j-9";
export var extraSmallText = "_6j-5";
export var fulfillmentGroupTable = "_6j-e";
export var largeText = "_6j-3";
export var loadingSpinnerContainer = "_6j-j";
export var mediumText = "_6j-2";
export var narrow = "_6j-f";
export var notificationLink = "_6j-l";
export var packageCheckIconContainer = "_6j-7";
export var slideoutHeaderActions = "_6j-g";
export var slideoutHeaderActionsShifted = "_6j-h";
export var slideoutHeaderContainer = "_6j-a";
export var slideoutModal = "_6j-c";
export var stickyHeaderWrapper = "_6j-b";
export var table = "_6j-k";
export var tableContainer = "_6j-d";
export var tertiaryText = "_6j-1";